import { render, staticRenderFns } from "./InviteCodePopup.vue?vue&type=template&id=71d394b5&scoped=true"
import script from "./InviteCodePopup.vue?vue&type=script&lang=ts"
export * from "./InviteCodePopup.vue?vue&type=script&lang=ts"
import style0 from "./InviteCodePopup.vue?vue&type=style&index=0&id=71d394b5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71d394b5",
  null
  
)

export default component.exports